import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9 6C7.33428 6 5.98394 7.34315 5.98394 9C5.98394 10.6569 7.33428 12 9 12C10.6657 12 12.0161 10.6569 12.0161 9C12.0161 7.34315 10.6657 6 9 6ZM7.49197 9C7.49197 8.17157 8.16714 7.5 9 7.5C9.83286 7.5 10.508 8.17157 10.508 9C10.508 9.82843 9.83286 10.5 9 10.5C8.16714 10.5 7.49197 9.82843 7.49197 9Z",
  fill: "#B82025"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9 3C6.51708 3 4.75294 4.12926 3.57803 5.37039C2.41538 6.59859 1.80963 7.95317 1.59463 8.50089C1.46846 8.82232 1.46846 9.17767 1.59463 9.49911C1.80963 10.0468 2.41538 11.4014 3.57803 12.6296C4.75294 13.8707 6.51708 15 9 15C11.4829 15 13.2471 13.8707 14.422 12.6296C15.5846 11.4014 16.1904 10.0468 16.4054 9.49911C16.5315 9.17768 16.5315 8.82233 16.4054 8.50089C16.1904 7.95317 15.5846 6.59859 14.422 5.37039C13.2471 4.12926 11.4829 3 9 3ZM4.67595 11.6013C3.73039 10.6025 3.21327 9.48638 3.01783 9C3.21327 8.51362 3.73039 7.39755 4.67595 6.39868C5.64074 5.37951 7.03062 4.5 9 4.5C10.9694 4.5 12.3593 5.37951 13.324 6.39869C14.2696 7.39755 14.7867 8.51362 14.9822 9C14.7867 9.48638 14.2696 10.6025 13.324 11.6013C12.3593 12.6205 10.9694 13.5 9 13.5C7.03062 13.5 5.64074 12.6205 4.67595 11.6013Z",
  fill: "#B82025"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}